const transformStatusOptions = (apiStatusOptions) => {
    return Object.values(apiStatusOptions).map(({ name }) => {
        const key = name.toLowerCase();
        return {
            value: key.replace(/\s+/g, ''),
            label: name,
        };
    });
};

export default transformStatusOptions;